<template>
  <div class="shapes js-shapes" :class="{ 'is-visible': isVisible }">
    <div class="inner">
      <div class="layer js-first-layer">
        <div class="shape shape--stick is-45 is-grey is-first"></div>
      </div>
      <div class="layer is-second js-second-layer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shapes',
  props: {
    mouse: Object,
    number: Number,
    isDekstop: Boolean,
    isVisible: Boolean,
    tilt: Object
  },
  data() {
    return {
      $firstLayer: null,
      $secondLayer: null,
      w: 0,
      h: 0,
      centerX: 0,
      centerY: 0
    };
  },

  watch: {
    mouse(mouse) {
      this.updateLayers();
    },
    tilt(tilt) {
      this.updateLayers();
    }
  },

  mounted() {
    this.$firstLayer = this.$el.querySelector('.js-first-layer');
    this.$secondLayer = this.$el.querySelector('.js-second-layer');
    this.w = this.$el.offsetWidth;
    this.h = this.$el.offsetHeight;
    this.centerX = window.innerWidth / 2;
    this.centerY = window.innerHeight / 2;

    let shape;
    let shapeInner;
    let shapeX;
    let shapeY;
    let offsetY;
    let shapeClass;

    offsetY = this.isDekstop ? 150 : 85;

    const rotation = [0, 45, 90, 135];
    const bgColor = ['#F0F2F2', '#E54B4B', '#38489D'];
    const scale = [0.5, 0.75, 1];
    const shapes = [
      'stick',
      'stick',
      'stick',
      'circle',
      'circle',
      'circle',
      'empty-circle',
      'empty-circle',
      'crop-circle',
      'half-circle',
      'half-circle'
    ];

    // generate shapes
    for (let i = 0; i < this.number; i++) {
      shape = document.createElement('div');
      shapeInner = document.createElement('div');
      shapeInner.classList.add('shape-inner');
      shape.classList.add('shape');
      shapeX = Math.floor(Math.random() * this.w) - 40;
      shapeY =
        Math.floor(Math.random() * (this.h - offsetY - offsetY)) + offsetY;

      shapeClass = shapes[Math.floor(Math.random() * shapes.length)];
      shape.classList.add(`shape--${shapeClass}`);

      const shapeColor = bgColor[Math.floor(Math.random() * bgColor.length)];

      TweenMax.set(shape, {
        x: shapeX,
        y: shapeY,
        rotation: rotation[Math.floor(Math.random() * rotation.length)],
        backgroundColor: shapeColor,
        scale: scale[Math.floor(Math.random() * scale.length)]
      });

      if (shapeClass === 'empty-circle') {
        TweenMax.set(shape, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
      } else if (shapeClass === 'crop-circle') {
        TweenMax.set(shape, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
        TweenMax.set(shapeInner, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
      }

      if (i % 2 === 0) {
        this.$firstLayer.appendChild(shape);
      } else {
        this.$secondLayer.appendChild(shape);
      }

      shape.appendChild(shapeInner);
    }
  },

  methods: {
    updateLayers() {
      let x;
      let y;

      if (this.isDekstop) {
        x = this.mouse.x;
        y = this.mouse.y;
      } else {
        x = this.tilt.x * 17.5;
        y = this.tilt.y * 17.5;
      }

      if (x === 0 && y === 0) {
        return;
      }

      const sensibility = 0.095;
      const parallaxDepth = 1.9;

      let dX;
      let dY;
      let offsetX;
      let offsetY;

      dX = x - this.centerX;
      dY = y - this.centerY;

      offsetX = dX * sensibility;
      offsetY = dY * sensibility;

      TweenMax.set(this.$firstLayer, {
        x: offsetX,
        y: offsetY,
        force3D: true
      });

      TweenMax.set(this.$secondLayer, {
        x: offsetX / parallaxDepth,
        y: offsetY / parallaxDepth,
        force3D: true
      });
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~include-media/dist/_include-media.scss';

.shapes {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  overflow: hidden;
  opacity: 0;
  transform: scale3d(1.1, 1.1, 1.1);
  transition: opacity 0.6s $easeInOutQuad, transform 0.6s $easeOutQuart;

  &.is-visible {
    opacity: 1;
    transform: scale3d(1, 1, 1);
    transition-delay: 0.2s;
  }
}

.inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss" rel="stylesheet/scss">
@import '~include-media/dist/_include-media.scss';

.shape {
  position: absolute;
  display: block;

  &.is-first {
    z-index: 1;
    top: 50%;
    left: 50%;
    background-color: $offwhite;
    width: 635px;
    height: 25px;
    border-radius: 25px;
    transform: translate(-50%, -50%) rotate(45deg);
  }
}

.layer {
  z-index: -10;

  &.is-second {
    z-index: -20;
  }
}

.shape-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape--stick {
  width: 90px;
  border-radius: 25px;
  height: 12px;
}

.shape--circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}

.shape--empty-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border-width: 7px;
  border-style: solid;
  background-color: transparent;
}

.shape--crop-circle {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 3px solid green;

  .shape-inner {
    width: 97px;
    height: 97px;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    border: 3px solid purple;
    transform: translate(-50%, -50%);
  }
}

.shape--half-circle {
  width: 35px;
  height: 70px;
  border-bottom-left-radius: 70px;
  border-top-left-radius: 70px;
}

@include media('<=tablet') {
  .shape {
    &.is-first {
      width: 350px;
      height: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Shapes.vue?526ab74c